import type { IUserFilterConfig, IUserFilterScopeChart } from '@dbl/core/dashboard';

export const getScopeChartIds = (
  scopeCharts: IUserFilterScopeChart[] | undefined,
): string[] => {
  return (scopeCharts || [])
    .map((item) => item?.task_id)
    .filter((taskId) => taskId !== null && taskId !== undefined && taskId !== '')
    .map((taskId) => String(taskId));
};

export const buildScopeChartsFromSelectedIds = (
  chartList: IUserFilterScopeChart[],
  selectedIds: string[],
): IUserFilterScopeChart[] => {
  const selectedIdSet = new Set(selectedIds.map(String));

  return (chartList || [])
    .filter((item) => selectedIdSet.has(String(item?.task_id)))
    .map((item) => ({
      task_id: item.task_id,
      name: item.name,
      nameCn: item.name_cn,
      chart_type: item.chart_type,
      table_id: item.table_id,
    }));
};

export const hasUserFilterControls = (userFilter: IUserFilterConfig): boolean => {
  const { controls } = userFilter || {};
  return Array.isArray(controls) && controls.length > 0;
};

